import { render } from "./EditDiagramModal.vue?vue&type=template&id=d2044650"
import script from "./EditDiagramModal.vue?vue&type=script&lang=js"
export * from "./EditDiagramModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__